import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class ExportService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  async exportFeatures(projectId: string): Promise<Blob> {
    var response = await this.http
      .get(this.env.managirUrl + "/actions/export/features/" + projectId, {
        observe: "response",
        responseType: "blob",
      })
      .toPromise();
    return response.body;
  }

  async exportSprint(sprintId: string): Promise<Blob> {
    var response = await this.http
      .get(this.env.managirUrl + "/actions/export/sprint/" + sprintId, {
        observe: "response",
        responseType: "blob",
      })
      .toPromise();
    return response.body;
  }

  async exportRetrospective(retrospectiveId: string): Promise<Blob> {
    var response = await this.http
      .get(
        this.env.managirUrl +
          "/actions/export/retrospective/" +
          retrospectiveId,
        { observe: "response", responseType: "blob" }
      )
      .toPromise();
    return response.body;
  }

  async exportAnnotations(projectId: string): Promise<Blob> {
    var response = await this.http
      .get(this.env.managirUrl + "/actions/export/annotations/" + projectId, {
        observe: "response",
        responseType: "blob",
      })
      .toPromise();
    return response.body;
  }

  async exportStatistik(): Promise<Blob> {
    var response = await this.http
      .get(this.env.managirUrl + "/actions/export/statistik", {
        observe: "response",
        responseType: "blob",
      })
      .toPromise();
    return response.body;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/export/export.service.ts